export default "__VITE_ASSET__DfLrsm6b__"